import { Storage } from "aws-amplify";
import React from "react";
import { toast } from "react-toastify";
import { DownloadIconAlt } from "../../assets/svgs";
import { Position, PositionImage } from "../../interfaces";
import { asyncForEach, downloadImage } from "../../utils";
import Zip from "jszip";
import FileSaver from "file-saver";
import { useRequest } from "ahooks";
import { LoadingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const zip = new Zip();

type Props = {
  positions?: Position[];
};

const DownloadImages: React.FC<Props> = ({ positions }) => {
  const { t } = useTranslation();

  const handleDownload = async () => {
    if (
      !positions ||
      positions.reduce(
        (acc, curr) => acc + (curr.positionImage?.length || 0),
        0,
      ) === 0
    ) {
      toast.info(t("noFiles"));
      return;
    }

    const images: PositionImage[] = positions
      .map((position: Position) => position?.positionImage)
      .reduce((a: any, b: any) => a.concat(b), [])
      .filter((i: PositionImage) => i);

    await asyncForEach(images, async (image: PositionImage) => {
      const key = image.pdfKey || image.key;
      const signedUrl: string = await Storage.get(key);
      const blob: any = await downloadImage(signedUrl);
      zip.file(key, blob);
    });

    zip.generateAsync({ type: "blob" }).then(function (content) {
      FileSaver.saveAs(content, `${Date.now()}-images.zip`);
    });
  };

  const { run, loading } = useRequest(handleDownload, { manual: true });

  return (
    <div
      onClick={() => {
        if (!loading) run();
      }}
      className="download-images"
      style={{ pointerEvents: loading ? "none" : "auto" }}
    >
      <span>
        {loading ? <LoadingOutlined /> : <DownloadIconAlt color="#0071e3" />}
      </span>
      <span>{t("downloadAll")}</span>
    </div>
  );
};

export default DownloadImages;
